/* eslint-disable func-names */
/* eslint-disable object-shorthand */
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-balham.css';
import './index.scss';

import React, { Component } from 'react';
import AgGridReactComponent from '../../../../common/components/ag-grid-react-component';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';
import { formatGivenDate } from '../../../../shared/services/common-functions';

const showInfinity = value => {
    if ( value > 99999 ) return 'Infinite';
    return value;
};

const excelStyles = [
    {
        id: 'greenBackground',
        interior: {
            color: '#b5e6b5',
            pattern: 'Solid'
        }
    },
    {
        id: 'centerText',
        alignment: {
            horizontal: 'Center'
        }
    },
    {
        id: 'redFont',
        interior: {
            color: '#ffcccc',
            pattern: 'Solid'
        }
    },
    {
        id: 'oddRowBackground',
        interior: {
            color: '#f7f7f7',
            pattern: 'Solid'
        }
    },
    {
        id: 'boldBorders',
        borders: {
            borderBottom: {
                color: '#000000',
                lineStyle: 'Continuous',
                weight: 3
            },
            borderLeft: {
                color: '#000000',
                lineStyle: 'Continuous',
                weight: 3
            },
            borderRight: {
                color: '#000000',
                lineStyle: 'Continuous',
                weight: 3
            },
            borderTop: {
                color: '#000000',
                lineStyle: 'Continuous',
                weight: 3
            }
        }
    },
    {
        id: 'header',
        interior: {
            color: '#CCCCCC',
            pattern: 'Solid'
        },
        borders: {
            borderBottom: {
                color: '#5687f5',
                lineStyle: 'Continuous',
                weight: 1
            },
            borderLeft: {
                color: '#5687f5',
                lineStyle: 'Continuous',
                weight: 1
            },
            borderRight: {
                color: '#5687f5',
                lineStyle: 'Continuous',
                weight: 1
            },
            borderTop: {
                color: '#5687f5',
                lineStyle: 'Continuous',
                weight: 1
            }
        }
    },
    {
        id: 'dateFormat',
        dataType: 'dateTime',
        numberFormat: { format: 'mm/dd/yyyy;@' }
    },
    {
        id: 'twoDecimalPlaces',
        numberFormat: { format: '#,##0.00' }
    },
    {
        id: 'textFormat',
        dataType: 'string'
    },
    {
        id: 'bigHeader',
        font: { size: 25 }
    },
    {
        id: 'regularHeader',
        font: { size: 14 }
    }
];

class GroupAvailabilityTable extends Component {

    onGridReady = params => {

        this.gridApi = params.api;

    }

    exportExcel = () => {

        const colKeys = this.gridApi.getAllGridColumns();
        const message = 'Group Availabiity';
        const title = 'Group Availabiity';
        const generalParams = {
            fileName: title,
            sheetName: 'Group Availabiity',
            exportMode: 'xlsx',
            columnKeys: colKeys,
            prependContent: [
                [],
                [
                    {
                        styleId: 'regularHeader',
                        data: {
                            type: 'String',
                            value: message
                        },
                        mergeAcross: 11
                    }
                ],
                []
            ]

        };

        this.gridApi.exportDataAsExcel( generalParams );

    };

    getColumnDefs = () => {

        const colDefs = [];

        colDefs.push(
            {
                field: 'itemDesc',
                headerName: 'Item Availability',
                sortable: false,
                filter: true,
                width: 195,
                cellRenderer: params => {

                    if ( params.value === 'Total Capacity' ||
                params.value === 'Total Ordered' ||
                params.value === 'Total Available' ||
                params.value === 'TOTAL' ) return ( <span>{params.value}</span> );
                    return ( <Link to={`/${params.data.unitName}/order/availability?constrainttype=G&constraintkey=${params.value}`}>{params.value}</Link> );

                }
            }
        );

        this.props.lastWeeks.forEach( weekObj => {

            const weekEnding = formatGivenDate( weekObj.weekEnding, 'YYYY-MM-DD' );
            const selectedWeekEnding = formatGivenDate( Number( this.props.selectedLastWeek ), 'YYYY-MM-DD' );

            if ( weekEnding === selectedWeekEnding ||
            new Date( weekEnding ) < new Date( selectedWeekEnding ) ) {

                const dateVal = weekObj.weekEnding;
                const headerName = `${weekObj.monthNumber} \n ${formatGivenDate( Number( dateVal ), 'DDMMMYY' )}`.toUpperCase();
                const dateField = formatGivenDate( Number( dateVal ), 'YYYY-MM-DD' );

                if ( dateField !== '2000-01-01' && dateField !== '2000-02-01' ) {

                    colDefs.push(
                        {

                            field: `${Number( dateVal )}`,
                            headerName: `${headerName}`,
                            sortable: true,
                            filter: true,
                            width: 105,
                            valueFormatter: params => showInfinity( params.value ),
                            cellClassRules: {
                                redFont: function ( params ) {

                                    return params.value < 0;

                                }
                            }

                        }
                    );

                }

            }

        } );
        return colDefs;

    };

getTableResult = () => {

    const tableResult = [];
    let groupAvailabilityResult = [];
    if ( this.props.results && this.props.results.groupAvailability ) {

        this.props.results.groupAvailability.forEach( tempResult => {

            const nestedTableResult = [];
            nestedTableResult.itemDesc = tempResult.groupName;
            tableResult.push( nestedTableResult );

            const nestedCapacityTDResult = {};
            nestedCapacityTDResult.itemDesc = 'Total Capacity';

            const nestedOrderedTDResult = {};
            nestedOrderedTDResult.itemDesc = 'Total Ordered';

            const nestedAvailableTDResult = {};
            nestedAvailableTDResult.itemDesc = 'Total Available';

            Object.keys( tempResult.availabilityDetails ).forEach( item => {

                nestedCapacityTDResult[item] = tempResult.availabilityDetails[item].totalCapacity;
                nestedAvailableTDResult[item] = tempResult.availabilityDetails[item].totalAvailable;
                nestedOrderedTDResult[item] = tempResult.availabilityDetails[item].totalOrdered;

            } );
            tableResult.push( nestedCapacityTDResult );
            tableResult.push( nestedOrderedTDResult );
            tableResult.push( nestedAvailableTDResult );

        } );

        if ( this.props.results && this.props.results.totalAvailability ) {

            const nestedTableResult = [];
            nestedTableResult.itemDesc = 'TOTAL';
            tableResult.push( nestedTableResult );

            const nestedCapacityTDResult = {};
            nestedCapacityTDResult.itemDesc = 'Total Capacity';

            const nestedOrderedTDResult = {};
            nestedOrderedTDResult.itemDesc = 'Total Ordered';

            Object.keys( this.props.results.totalAvailability ).forEach( item => {

                nestedCapacityTDResult[item] =
                 this.props.results.totalAvailability[item].totalCapacity;
                nestedOrderedTDResult[item] =
                 this.props.results.totalAvailability[item].totalOrdered;

            } );
            tableResult.push( nestedCapacityTDResult );
            tableResult.push( nestedOrderedTDResult );

        }
        const additionalInfo = { unitName: this.props.unitCode };
        groupAvailabilityResult = tableResult.map( i => ( { ...i, ...additionalInfo } ) );

    }
    return groupAvailabilityResult;

};

render () {

    const columnDefs = this.getColumnDefs();
    const tableResult = this.getTableResult();

    return (

        <section className="atp-search-result-panel group-availability-result-panel ">

            <div className="atp-ag-grid ag-theme-balham ag-theme-popupbg">
                <AgGridReactComponent
                    reactNext={true}
                    columnDefs={columnDefs}
                    rowData={tableResult}
                    onGridReady={this.onGridReady}
                    headerHeight={56}
                    excelStyles={excelStyles}
                />
            </div>

        </section>
    );

}

}

GroupAvailabilityTable.propTypes = {
    results: PropTypes.object.isRequired,
    unitCode: PropTypes.string.isRequired,
    selectedLastWeek: PropTypes.string.isRequired,
    lastWeeks: PropTypes.array.isRequired
};
export default GroupAvailabilityTable;
